"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_UINT = exports.priceFeedNetworks = exports.latestAugustusVersion = exports.AdapterAugustusVersionMap = exports.AugustusVersion = exports.PricingMethod = exports.ContractMethod = exports.SwapSide = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
var SwapSide;
(function (SwapSide) {
    SwapSide["BUY"] = "BUY";
    SwapSide["SELL"] = "SELL";
})(SwapSide = exports.SwapSide || (exports.SwapSide = {}));
var ContractMethod;
(function (ContractMethod) {
    ContractMethod["swapOnUniswap"] = "swapOnUniswap";
    ContractMethod["buyOnUniswap"] = "buyOnUniswap";
    ContractMethod["swapOnUniswapFork"] = "swapOnUniswapFork";
    ContractMethod["buyOnUniswapFork"] = "buyOnUniswapFork";
    ContractMethod["simpleBuy"] = "simplBuy";
    ContractMethod["simpleSwap"] = "simpleSwap";
    ContractMethod["multiSwap"] = "multiSwap";
    ContractMethod["buy"] = "buy";
    ContractMethod["megaSwap"] = "megaSwap";
})(ContractMethod = exports.ContractMethod || (exports.ContractMethod = {}));
var PricingMethod;
(function (PricingMethod) {
    PricingMethod["megapath"] = "megapath";
    PricingMethod["multipath"] = "multipath";
    PricingMethod["simplepath"] = "simplepath";
})(PricingMethod = exports.PricingMethod || (exports.PricingMethod = {}));
var AugustusVersion;
(function (AugustusVersion) {
    AugustusVersion[AugustusVersion["v2"] = 2] = "v2";
    AugustusVersion[AugustusVersion["v3"] = 3] = "v3";
    AugustusVersion[AugustusVersion["v4"] = 4] = "v4";
})(AugustusVersion = exports.AugustusVersion || (exports.AugustusVersion = {}));
exports.AdapterAugustusVersionMap = {
    ['2.0.0']: AugustusVersion.v2,
    ['2.1.0']: AugustusVersion.v2,
    ['2.2.0']: AugustusVersion.v2,
    ['3.0.0']: AugustusVersion.v3,
    ['4.0.0']: AugustusVersion.v4,
};
exports.latestAugustusVersion = AugustusVersion.v4;
exports.priceFeedNetworks = {
    1: '0x12295f06DA62693086F5DA45b78e20B778060853',
    42: '',
};
exports.MAX_UINT = new bignumber_js_1.default(2).pow(256).minus(1);
//# sourceMappingURL=constants.js.map